<script setup lang="ts">
import {ArrowUp} from 'lucide-vue-next';
import {RouterView} from 'vue-router';
import NavBar from './components/NavBar.vue';
import SiteFooter from './components/SiteFooter.vue';
import TopBar from './components/TopBar.vue';
</script>

<template>
  <TopBar />
  <NavBar />
  <main id="top">
    <RouterView />
  </main>
  <SiteFooter />
  <a class="back-to-top" href="#top" aria-label="Back to top"><ArrowUp /></a>
</template>
